import { useRouter } from 'next/navigation'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, Notification } from 'base-ui'

export const DirectContactFormSuccessNotification: FC<{
  handleSuccessClose?: () => void
  isCancelContract?: boolean
  onClose: () => void
}> = ({ handleSuccessClose, isCancelContract, onClose }) => {
  const router = useRouter()

  const handleClose = (): void => {
    onClose()

    if (handleSuccessClose) {
      handleSuccessClose()
    }

    if (isCancelContract) {
      router.back()
    }
  }

  return (
    <>
      <Notification
        className="container my-8 mt-0 w-full"
        data-qa-id="productConsultationMessageSuccess"
        severity="success"
      >
        <p className="font-medium text-dark-success">
          <FormattedMessage id="direct.contact.form.submit.success.sub.header" />
        </p>
        {isCancelContract ? (
          <FormattedMessage id="direct.contact.form.submit.cancel.contract.success" />
        ) : (
          <FormattedMessage id="direct.contact.form.submit.success.notification.text" />
        )}
      </Notification>
      <Button
        className="mt-auto w-full"
        onClick={handleClose}
        size="large"
        variant="filled"
      >
        <FormattedMessage id="general.link.label.close" />
      </Button>
    </>
  )
}
